// Mutations
const UPDATE_BASKET_INDEX           = "UPDATE_BASKET_INDEX";
const UPDATE_BASKET_INDEX_DELIVERY  = "UPDATE_BASKET_INDEX_DELIVERY";
const EMPTY_BASKET                  = "EMPTY_BASKET";
const UPDATE_QUANTITY_CONFIG        = "UPDATE_QUANTITY_CONFIG";
const PUSH_TO_BASKET                = "PUSH_TO_BASKET";
const REMOVE_FROM_BASKET            = "REMOVE_FROM_BASKET";
const INITIALISE_STORE              = "INITIALISE_STORE";
const SET_PENDING_ORDER             = 'SET_PENDING_ORDER';
const CLEAR_PENDING_ORDER           = 'CLEAR_PENDING_ORDER';
const SET_GROUPED_FULFILMENT_CONFIG = 'SET_GROUPED_FULFILMENT_CONFIG';
const RESET_GROUPED_FULFILMENT_CONFIG = 'RESET_GROUPED_FULFILMENT_CONFIG';
const SET_RECIPIENT_CONTACT         = 'SET_RECIPIENT_CONTACT';
const SET_VALIDATED_ORDER           = 'SET_VALIDATED_ORDER';
const RESET_STORE                   = 'RESET_STORE';
const SET_GROUP_CARD_TYPES          = "SET_GROUP_CARD_TYPES";
const SET_FORCE_INDIVIDUAL_DELIVERY = "SET_FORCE_INDIVIDUAL_DELIVERY";
const SET_PRODUCT_SCHEDULING        = "SET_PRODUCT_SCHEDULING";
const SET_GROUPED_SCHEDULING        = "SET_GROUPED_SCHEDULING";
const UPDATE_RECEIPT_CONTACT        = 'UPDATE_RECEIPT_CONTACT';
const REMOVE_DISCOUNT_CODE                 = 'REMOVE_DISCOUNT_CODE';
const SET_BASKET_PROMOTION_CODE            = 'SET_BASKET_PROMOTION_CODE';
const SET_BASKET_DISCOUNT_VALUE            = 'SET_BASKET_DISCOUNT_VALUE';
const SET_BASKET_DISCOUNTS                 = 'SET_BASKET_DISCOUNTS';


function initialState () {
  return {
    basket:[],
    basketPromotionalCode : {code:'',pin:'',value:0},
    basketDiscountValue   : 0,
    basketDiscounts       : [],
    force_individual_delivery: false,
    product_scheduling: false,
    grouped_scheduling: false,
    group_card_types: true,
    validated_order : false,
    pending_order:{
      id               : null,
      remaining_balance: 0,
      balance_paid     : 0,
      hash             : null
    },
    grouped_fulfilment_config:{
      name          : '',
      first_name    : '',
      last_name     : '',
      address_line_1: '',
      address_line_2: '',
      town_city     : '',
      postcode      : '',
      country_code  : '',
      post_type     : false,
      email         : '',
      email_type    : false,
      recipient_type: 'Someone else',
      phone_number: ''
    },
    receiptContact : {
      email        : '',
      first_name   : '',
      last_name    : '',
      phone_number : ''
    }
  }
}

export const state = () => initialState();

export const mutations = {


      [REMOVE_DISCOUNT_CODE] (state){
        state.basketPromotionalCode = {code:'',pin:'',value:0};
        state.basketDiscountValue = 0;
        state.basketDiscounts   = [];
      },

      [SET_BASKET_PROMOTION_CODE] (state, value) {
        state.basketPromotionalCode = value;
      },

      [SET_BASKET_DISCOUNT_VALUE ] (state, value) {
        state.basketDiscountValue = value;
      },

      [SET_BASKET_DISCOUNTS ] (state, value) {
        state.basketDiscounts = value;
      },


      //////

    [RESET_STORE] (state) {
      // acquire initial state
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },

    /**
    * Store choosen delivery card type (grouped or individual - true or false)
    * @type {bool} delivery card type
    */
    [SET_GROUP_CARD_TYPES](state, value) {
      state.group_card_types = value;
    },


    /**
     * Force individual item delivery
     * Used when group fulfilment has no common postage types for all order items
     * So we force the user to send individually
     * @type {bool} delivery card type
     */
    [SET_FORCE_INDIVIDUAL_DELIVERY](state, value) {
      state.force_individual_delivery = value;
    },

    [SET_PRODUCT_SCHEDULING](state, value) {
      state.product_scheduling = value;
    },

    [SET_GROUPED_SCHEDULING](state, value) {
      state.grouped_scheduling = value;
    },

    [SET_VALIDATED_ORDER] (state, value)
    {
      state.validated_order = value;
    },

    /**
     * Initialises the store to the last state saved in local storage
     */
    [INITIALISE_STORE](state) {

      try{

        // Check if the ID exists
        if(localStorage.getItem('toggle_basket')) {
          // Replace the state object with the stored item
          let savedState = JSON.parse(localStorage.getItem('toggle_basket'));
          Object.keys(savedState).forEach(key => {
            state[key] = savedState[key]
          });
        }
      }catch(e) { // local storage disabled, so we won't use it.
        return false;
      }

    },
    /**
    * Replace basket index with a new basket object
    * @type {object}
    */
    [UPDATE_BASKET_INDEX](state, value)
    {
      state.basket.splice(value.index,1,value.value);
    },
    
    [UPDATE_BASKET_INDEX_DELIVERY](state, value)
    {
        state.basket[value.basket_index].delivery_type = value.delivery_type
    },

    [EMPTY_BASKET](state){
      const s = initialState();
      state.basket = s.basket;
      state.grouped_fulfilment_config = s.grouped_fulfilment_config;
    },

    /**
    * Replace basket index with a new basket object
    * @type {object}
    */
    [UPDATE_QUANTITY_CONFIG](state, value)
    {
      Object.assign(state.basket[value.basket_index].quantity_config[value.quantity_index], value.value);
    },



    /**
    * Add an item to the basket
    * @type {object} basket item
    */
    [PUSH_TO_BASKET](state, product) {
      state.basket.push(product);
    },

    /**
    * Remove an index from the basket
    * @type {integer} index
    */
    [REMOVE_FROM_BASKET](state, index) {
      state.basket.splice(index,1);
    },

    [CLEAR_PENDING_ORDER] (state) {
      // acquire initial state
      const s = initialState();
      state.pending_order = s.pending_order;
    },

    [SET_PENDING_ORDER] (state, value){
      state.pending_order = value;
    },


    /**
    * Set an index of the billing address
    * @type {object}
    */
    [SET_GROUPED_FULFILMENT_CONFIG](state,value){
      Object.assign(state.grouped_fulfilment_config, value);
    },
    /**
    * Reset the grouped fulfilment config to the initial state
    */
    [RESET_GROUPED_FULFILMENT_CONFIG](state, preserveEmail){
      const s = initialState();
      const email = state.grouped_fulfilment_config.email;
      state.grouped_fulfilment_config = s.grouped_fulfilment_config;
      if(preserveEmail) {
        state.grouped_fulfilment_config.email = email;
      }
    },

    [UPDATE_RECEIPT_CONTACT](state, value){
      Object.assign(state.receiptContact, value);
    }
}

export const getters = {


  getBasketPromotionalCode:state => {
    return state.basketPromotionalCode;
  },

  getBasketDiscountValue:state => {
    return state.basketDiscountValue;
  },

  getBasketDiscounts:state => {
    return state.basketDiscounts;
  },

  /////


    getBasket: state => {
      return state.basket
    },

    // returns bool. True if the basket contains an automatic promotion and false if it doesn't

    getBasketContainsAutomaticPromotions: (state, getters,  rootState, rootGetters) => {
      let basket =  state.basket;
      let automatic_promotions = [];
      for(let i=0; i < basket.length; i++){
        rootGetters.getProductById(basket[i].id).AutomaticPromotions.data.map(object => object.id).forEach(promotion_id => {
          automatic_promotions.push(promotion_id);
        });
      }
      return automatic_promotions.length > 0 ? true : false;
    },
    getBasketItemByIndex: state => (index) => {
      return state.basket[index]
    },
    getBasketQuantityConfig: (state) => (basket_item_index, quantity_config_index) => {
      return state.basket[basket_item_index].quantity_config[quantity_config_index];
    },

    getGroupedFulfilmentConfig: (state) => {
      return state.grouped_fulfilment_config;
    },

    getPendingOrder:state => {
      return state.pending_order;
    },

    getGroupCardTypes: state => {
      return state.group_card_types;
    },

    getForceIndividualDelivery: state => {
      return state.force_individual_delivery
    },

    getProductScheduling: state => {
      return state.product_scheduling;
    },

    getGroupedScheduling: state => {
      return state.grouped_scheduling;
    },
    getReceiptContact:state => {
      return state.receiptContact;
    }

}


export const actions = {


  cancelPendingOrder({commit}, pendingOrder){

      commit('CLEAR_PENDING_ORDER');

      this.$axios({
        url: process.env.VUE_APP_API_BASE_URL + '/graphql',
        method: 'post',
        data: {
          query: `
            mutation($id:Int!, $hash:String!) {
              cancelPendingOrder(id:$id, hash:$hash)
            }
          `,
          variables: {
            id   : pendingOrder.id,
            hash : pendingOrder.hash
          }
        }
      });

    },

}
